import getUserRole from "./getRole";

function filterByProductMessageType(itemArray, clientProductId, messageTypeId) {
    if (!Array.isArray(itemArray) || itemArray.length === 0) {
        return null;
    }
    // Find item based on the product ID and message type, product ID only, message type only, or no matching criteria
    return itemArray.find(i => i.ClientProductId === clientProductId && i.MessageTypeId === messageTypeId)
        || itemArray.find(i => !i.ClientProductId && i.MessageTypeId === messageTypeId)
        || itemArray.find(i => i.ClientProductId === clientProductId && !i.MessageTypeId)
        || itemArray.find(i => !i.ClientProductId && !i.MessageTypeId) 
        || null;
}

export function getConfigValue(item, appState) {
    try {
        const { currentProduct, category } = appState || {};
        const { clientProductId } = currentProduct || {};
        const { messageTypeId } = category || {};

        const userRole = getUserRole(appState);

        if (!userRole?.id) {
            return { };
        }

        if (Array.isArray(item)) {
            let result = null;
            
            //filter by the user specific role first
            let roleFiltered = item.filter(i => i.RoleId === userRole?.id);
            result = filterByProductMessageType(roleFiltered, clientProductId, messageTypeId);    
            
            if(result !== null) {
                return result;
            }
            
            //then filter by configs not associated to any role
            roleFiltered = item.filter(i => !i.RoleId);
            result = filterByProductMessageType(roleFiltered, clientProductId, messageTypeId);    
            if(result === null){
                console.warn("Unable to resolve config item for user role: ", userRole?.id);
                return {};
            }
            return result;
        }

        // Return the item or an empty object if item doesn't exist
        if (typeof item === "object" && item !== null) {
            if (item.RoleId && item.RoleId !== userRole?.id) {
                return {};
            }

            return item;
        }
        return item || {};
    } catch (error) {
        // Log errors and return an empty object
        console.error("Error in getConfigValue: ", error);
        return {};
    }
}

export function getConfigCollection(item, appState, rootName) {
    try {
        const result = {};
        const itemValue = getConfigValue(item, appState);
        //check the Value property exists, if the value is null, it should still asign it.
        if (itemValue?.Value !== undefined) {
            result[itemValue.Name] = itemValue.Value;
        } else {
            // Iterate over properties of each object
            Object.keys(itemValue).forEach((key) => {
                // process each property of the item
                const subItemName = `${rootName}.${key}`;
                const subItem = itemValue[key];
                const subValue = getConfigCollection(subItem, appState, subItemName);
                // merge the subItem into the result
                mergeObject(result, subItemName, getItemValue(subValue, subItemName));
            });
            return result;
        }
        // Return the item or an empty object if item doesn't exist
        return result || {};
    } catch (error) {
        // Log errors and return empty object
        console.error("Error in getConfigCollection: " + error + " rootName: " + rootName);
        return {};
    }

}

export function isBatchPrintEnabledForProduct(appState, productId) {
    const state = { currentProduct: { clientProductId: productId }, role: appState.role, roles: appState.roles };
    return getConfigValue(appState?.config?.BatchPrint?.Enabled, state)?.Value === 'true';
}

export function isBatchPrintEnabledForAnyProduct(appState) {
    for (const product of appState?.productDetails || []) {
        if (isBatchPrintEnabledForProduct(appState, product.clientProductId)) {
            return true;
        }
    }
    return false;
}

function getItemValue(valueContainer, name) {
    if (valueContainer[name]) {
        return valueContainer[name];
    }
    // Find the value in the nested object
    let currentLevel = valueContainer;
    name.split('.').forEach(namePart => {
        if (!currentLevel) {
            return null;
        }
        currentLevel = currentLevel[namePart];
    });
    return currentLevel;
}

function mergeObject(result, name, value) {

    let currentLevel = result;
    let propertyName = '';
    let lastParent = result;
    name.split('.').forEach(namePart => {
        if (!currentLevel.hasOwnProperty(namePart)) {
            currentLevel[namePart] = {};
        }
        lastParent = currentLevel;
        currentLevel = currentLevel[namePart];
        propertyName = namePart;
    })
    lastParent[propertyName] = value;
}